import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {LanguageProvider} from '../context/languageProvider';
import {
    MAIN_ROUTE,
} from "./constantsRoutes";
import CleanUrl from "./cleanUrl";
import LandingUnic from '../sections/landingUnic/LandingUnic';


const Routers = () => {

    return (
        <LanguageProvider>
            <BrowserRouter>
                <CleanUrl/>
                <Routes>
                    <Route path={MAIN_ROUTE} element={<LandingUnic/>}/>
                </Routes>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default Routers;